<template>
  <div id="addCompetePerson">
    <a-form :form="colleagueForm" layout="vertical">
      <div class="customerFormDiv">
        <a-row>
          <a-col :span="15">
            <a-form-item class="required" :label="$t('competePerson.addModal.companyFullNameLabel')">
              <pt-input
                v-decorator="['companyName',{rules: [
                {required: true,message: $t('competePerson.addModal.companyFullNameTip'),},
                {min: 2, max: 128, message: $t('competePerson.addModal.textSmallLength'), trigger: 'blur'},
                ],}]"
                :placeholder="$t('competePerson.addModal.companyFullNameTip')"></pt-input>
            </a-form-item>
          </a-col>
          <a-col :span="7" :offset="1">
            <a-form-item class="required" :label="$t('competePerson.addModal.companyNameCNLabel')">
              <pt-input
                v-decorator="['companySortNameCn',{rules: [
                {required: true,message: $t('competePerson.addModal.companyNameCNTip'),},
                {min: 2, max: 128, message: $t('competePerson.addModal.textSmallLength'), trigger: 'blur'},
                ],}]"
                :placeholder="$t('competePerson.addModal.companyNameCNTip')"></pt-input>
            </a-form-item>
          </a-col>
        </a-row>
        <!--<a-row>-->
          <!--<a-col :span="7" :offset="1">-->
            <!--<a-form-item class="required" :label="$t('competePerson.addModal.companyNameENLabel')">-->
              <!--<pt-input-->
                <!--v-decorator="['companySortNameEn',{rules: [-->
                <!--{required: true,message: $t('competePerson.addModal.companyNameENTip'),},-->
                <!--{min: 2, max: 128, message: $t('competePerson.addModal.textSmallLength'), trigger: 'blur'},-->
                <!--],}]"-->
                <!--:placeholder="$t('competePerson.addModal.companyNameENTip')"></pt-input>-->
            <!--</a-form-item>-->
          <!--</a-col>-->
          <!--<a-col :span="7" :offset="1">-->
            <!--<a-form-item :label="$t('competePerson.addModal.companyWebsitesLabel')">-->
              <!--<pt-input-->
                <!--v-decorator="['url',{rules: [-->
                <!--{min: 2, max: 256, message: $t('competePerson.addModal.textMaxLength'), trigger: 'blur'},-->
                <!--],}]"-->
                <!--:placeholder="$t('competePerson.addModal.companyWebsitesTip')"></pt-input>-->
            <!--</a-form-item>-->
          <!--</a-col>-->
        <!--</a-row>-->
      </div>
      <div v-if="colleagueId == null">
        <div class="expandMoreBtn" v-if="!contactVisible" @click="toggleContact(true)">
          <pt-icon type="icon-zengjia" class="expandIcon"></pt-icon>
          <div class="expandMoreText">{{$t('track.trackModal.contactLabel')}}</div>
        </div>
        <div class="expandDiv" v-if="contactVisible">
          <div class="expandTitleRow">
            <div class="circleYellow"></div>
            <div class="expandTitle">{{$t('track.trackModal.contactLabel')}}</div>
          </div>
          <div class="expandMoreDiv">
            <div class="closeExpandBtn" @click="toggleContact(false)">
              <pt-icon type="icon-guanbi-copy" class="closeIcon"></pt-icon>
            </div>
            <a-row v-if="contactList.length > 0">
              <a-col :span="5">
                <div class="labelText">{{$t('track.trackModal.contactNameLabel')}}<span style="font-size:14px;color:#f5222d;">*</span></div>
              </a-col>
              <a-col :span="5" :offset="1">
                <div class="labelText">{{$t('track.trackModal.positionLabel')}}</div>
              </a-col>
              <a-col :span="5" :offset="1">
                <div class="labelText">{{$t('track.trackModal.contactNum')}}</div>
              </a-col>
              <a-col :span="5" :offset="1">
                <div class="labelText">{{$t('track.trackModal.contactEmail')}}</div>
              </a-col>
            </a-row>
            <a-row v-for="(item,index) in contactList" :key="index">
              <a-col :span="5">
                <a-form-item>
                  <pt-input  v-decorator="[`linkmanDOList[${index}].name`,{rules: [
                  {required: true,message: $t('customer.customerModal.contactNameTip'),},
                ],}]" :placeholder="$t('track.trackModal.contactNameTip')"></pt-input>
                </a-form-item>
              </a-col>
              <a-col :span="5" :offset="1">
                <a-form-item>
                  <a-input  v-decorator="[`linkmanDOList[${index}].job`,{rules: [
                 {min: 2, max: 64, message: $t('customer.customerModal.textMinLength'), trigger: 'blur'},
                ],}]" :placeholder="$t('track.trackModal.positionTip')"></a-input>
                </a-form-item>
              </a-col>
              <a-col :span="5" :offset="1">
                <a-form-item>
                  <a-input  v-decorator="[`linkmanDOList[${index}].phone`,{rules: [
                  {min: 2, max: 64, message: $t('customer.customerModal.textMinLength'), trigger: 'blur'},
                ],}]" :placeholder="$t('track.trackModal.contactNum')"></a-input>
                </a-form-item>
              </a-col>
              <a-col :span="5" :offset="1">
                <a-form-item>
                  <a-input  v-decorator="[`linkmanDOList[${index}].email`,{rules: [
                  {
                    type: 'email',
                    message:$t('customer.customerModal.emailErrorTip'),
                  },
                  {min: 2, max: 256, message: $t('customer.customerModal.textMaxLength'), trigger: 'blur'},
                ],}]" :placeholder="$t('track.trackModal.contactEmail')">
                  </a-input>
                </a-form-item>
              </a-col>
              <a-col :span="1">
                <div class="deleteBtn" v-if="index !== 0" @click="deleteContactRow(index)">
                  <pt-icon type="icon-tubiao" class="delIcon"></pt-icon>
                </div>
              </a-col>
            </a-row>
            <a-row>
              <div class="addBtn" @click="addContactRow">
                <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
              </div>
            </a-row>
          </div>
        </div>
      </div>
    </a-form>
  </div>
</template>

<script>
  import {insert,update,selectOne} from '@/api/database/colleague';
  export default {
    name: 'addCompetePerson',
    props:{
      colleagueId: null,
    },
    data(){
      return{
        contactVisible:false,
        colleagueForm: this.$form.createForm(this,{}),
        contactList:[],
        fileDO:{
          id:"0"
        },//logo信息
        colleagueVO:{},//编辑信息
      }
    },
    beforeCreate () {
      this.colleagueForm = this.$form.createForm(this)
    },
    mounted(){
      this.init()
    },
    methods:{
      toggleContact(visible){
        this.contactVisible = visible;
        if(visible){
          this.addContactRow()
        }else{
          this.contactList = []
        }
      },
      init(){
        if(this.colleagueId){
          this.queryDetail();
        }
      },
      queryDetail(){
        let this_ = this
        selectOne(this_.colleagueId).then(res=>{
          if(res.code == 1){
            let temp = JSON.stringify(res.data)
            this_.colleagueVO = JSON.parse(temp.replace(/\"~\"/g,null))
            this_.fillForm();
          }
        })
      },
      fillForm(){
        this.fileDO.id = this.colleagueVO.logo;
        if(this.colleagueVO.linkmanDOList.length > 0){
          this.contactList = [];
          this.colleagueVO.linkmanDOList.forEach((data,index)=>{
            this.contactList.push(index);
          })
        }
        setTimeout(()=>{
          this.colleagueForm.setFieldsValue(this.colleagueVO);
        },0)
      },
      getImageUrl(){
        let url = this.$util.getFileUrl(this.fileDO.id);
        return url;
      },
      onSuccess(file,fileId,number){
        this.fileDO = Object.assign(file,{id:fileId});
      },
      deleteContactRow(index){
        let keys = this.colleagueForm.getFieldValue('linkmanDOList');
        this.colleagueForm.setFieldsValue({
          linkmanDOList: keys.filter((item,i) => index !== i),
        })
        this.contactList.splice(index,1);
      },
      addContactRow(){
        this.contactList.push(1);
      },
      submit(){
        this.colleagueForm.validateFieldsAndScroll({force:true},(err, values) => {
          if (!err) {
            this.fillData(values);
          }else{
            this.$emit("error");
          }
        });
      },
      fillData(data){
        if(this.colleagueId){
          data["id"] = this.colleagueId;
          data["version"] = this.colleagueVO.version;
        }
        data["logo"] = this.fileDO.id;
        if(this.colleagueId){
          this.update(data);
        }else{
          this.save(data);
        }
      },
      save(data){
        insert(data).then(res => {
          if (res.code == 1) {
            this.$message.success(this.$t('competePerson.addModal.saveSuccessTip'));
            this.$emit("saveSuccess",res.data.id,res.data.companyName,res.data);
          }else{
            this.$emit("error")
          }
        })
      },
      update(data){
        update(data).then(res => {
          if (res.code == 1) {
            this.$message.success(this.$t('competePerson.addModal.updateSuccessTip'));
            this.$emit("saveSuccess");
          }else{
            this.$emit("error")
          }
        })
      },
    }
  }
</script>

<style scoped lang="less">
  #addCompetePerson{
    .expandMoreBtn{
      background: #E8E8E8;
      border: 1px solid #DFDFDF;
      border-radius: 2px;
      height: 25px;
      display: inline-block;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 0 10px;
      cursor:pointer;
      margin-bottom: 5px;
      margin-top: 20px;
      .expandIcon{
        font-size: 12px;
      }
      .expandMoreText{
        display: inline;
        margin-left: 5px;
        font-size: 12px;
        color: #666666;
      }
    }
    .expandDiv{
      margin-top: 20px;
      .expandMoreDiv{
        padding: 20px 10px 0px 10px;
        background: #F2F4F6;
        border-radius: 2px;
        position: relative;
      }
      .closeExpandBtn{
        position: absolute;
        right: 0px;
        top:0px;
        width: 24px;
        height: 24px;
        border-radius:2px;
        background: #D3D3D3;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        .closeIcon{
          font-size: 14px;
          color: #FFFFFF;
        }
      }
      .expandTitleRow{
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 5px;
        .circleYellow{
          width: 12px;
          height: 12px;
          background: #FABE00;
          border-radius: 50%;
          margin-right: 10px;
        }
        .expandTitle{
          font-size: 14px;
          color: #333333;
        }
      }
    }
    .deleteBtn{
      margin-top: 10px;
      margin-left: 10px;
      cursor: pointer;
      .delIcon{
        font-size: 18px;
      }
    }
    .addBtn{
      width: 20px;
      height: 16px;
      border: 1px solid #FABE00;
      border-radius: 2px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      margin-bottom: 18px;
      .addIcon{
        font-size: 12px;
        color: #FABE00;
      }
    }
    .labelText{
      font-size: 12px;
      color: #999999;
      margin-left: 4px;
    }
    .customerFormDiv{
      background: rgba(248,249,251,0.62);
      border-radius: 0 0 4px 4px;
      padding: 20px;
    }
    .titleRow{
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 20px;
      margin-bottom: 5px;
      .circle{
        margin-left: 12px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: #FABE00;
      }
      .titleText{
        padding: 0 10px;
        color: #333333;
        font-size: 14px;
      }
    }
    .uploadText{
      font-size: 12px;
      color: #999999;
      margin-bottom: 5px;
    }
    .uploadImageDiv{
      width: 90px;
      height: 90px;
      background: #E3E3E3;
      border: 1px solid #D3D3D3;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      .addIcon{
        font-size: 18px;
        color: #454341;
      }
    }
    .labelDiv{
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }
    .labelItemActive{
      cursor: pointer;
      background: #FABE00;
      border-radius: 4px;
      width: 90px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      color: #333333;
      margin-right: 28px;
      margin-top: 14px;
    }
    .labelItem{
      cursor: pointer;
      background: #FFFFFF;
      border: 1px solid #EAEAEA;
      border-radius: 4px;
      width: 90px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      color: #333333;
      margin-right: 28px;
      margin-top: 14px;
    }
  }
</style>